import fa from '../objects/fa';
import en from '../objects/en';
import ar from '../objects/ar';
import CookieFunction from './cookieFunction';

const ChooseLanguage = (x = 'fa') => {
  const array = [
    {
      id: 1,
      content: fa,
      name: 'fa',
      dir: 'rtl',
    },
    {
      id: 2,
      content: en,
      name: 'en',
      dir: 'ltr',
    },
    {
      id: 2,
      content: ar,
      name: 'ar',
      dir: 'rtl',
    },
  ];
  let variable;
  if (x == 'fa' || x == 'en' || x == 'ar') {
    variable=x

  }else{
    variable = 'en';
    CookieFunction('set', 'ochattLang', 'en', () => {
    });

  }
  console.log("lang==", variable)
  let chosen=array.filter((lang) => lang.name == variable)?.[0]
  return chosen;
};

export default ChooseLanguage;
